var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu-item',{attrs:{"index":_vm.menu.path || _vm.uniqueId}},[(_vm.menu.icon)?_c('i',{class:`fa fa-${_vm.menu.icon}`}):(_vm.menu.iconSvg)?_c('d2-icon-svg',{attrs:{"name":_vm.menu.iconSvg}}):_c('i',{staticClass:"fa fa-file-o"}),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.menu.title || '未命名菜单'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }